import React from 'react';

import { useState, useEffect } from 'react';

import makeStyles from '@mui/styles/makeStyles';

import DialogContent from '@mui/material/DialogContent';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import FormControlLabel from '@mui/material/FormControlLabel';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';

import { ReclamationActionDetailType } from 'constants.js';
import { ReclamationActionDetailCodes } from 'constants.js';

const useStyles = makeStyles((theme) => ({
    formControl: {
        width: '100%',
        marginBottom: theme.spacing(1)
    },
}));




/* Liste des réponses possibles */
const demandeLabel = "Sélectionner qui fait la demande";
const demandes = [
    'le client',
    'Foussier (celui qui fait la saisie)',
];

function DeclarerMiseAuRebutProduitDialogContent({ onChange, action }) {


    const classes = useStyles();

    const [demande, setDemande] = useState('');


    useEffect(() => {
        onChange(null);
    }, [onChange]);


    useEffect(() => {


        const getActionData = () => {

            if (demande === '') {
                return null;
            }

            let actionData =
            {
                code: action.code,
                details: [
                    {
                        code: ReclamationActionDetailCodes.Resultat,
                        type: ReclamationActionDetailType.ChoixSimple,
                        libelle: demandeLabel,
                        position: 0,
                        valeurString: demandes[demande],
                        valeurInteger: demande
                    }]
            };



            return actionData;
        }


        onChange(getActionData());
    }, [action.code, onChange, demande]);


    return (
        <DialogContent>

            <FormControl component="fieldset" className={classes.formControl}>
                <FormLabel component="legend">{demandeLabel}</FormLabel>
                <RadioGroup
                    value={demande.toString()}
                    onChange={e => setDemande(parseInt(e.target.value, 10))}
                >
                    {demandes.map((m, index) => (
                        <FormControlLabel key={index} value={index.toString()} control={<Radio />} label={m} />
                    ))}

                </RadioGroup>
            </FormControl>
        </DialogContent>
    );

}


export default DeclarerMiseAuRebutProduitDialogContent;